var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper dashboard-wrapper"},[_c('Navbar'),_c('SearchFilters',{on:{"refresh-table":_vm.triggerTableRefresh}}),_c('Table',{key:_vm.url,ref:"tableComponent",attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }